<template>
	<div id='vxeTable'>

        <vxe-table
          border
          resizable
          highlight-hover-row
          highlight-current-row
           ref="xTable"
          height='100%'
          :loading="table.loading"
          :data="table.data"
          :show-footer='table.hasShowSummary'
          :footer-method="table.footerMethod"
          @edit-closed='table.editClosedEvent'
          @edit-actived="editActivedEvent"
          :header-cell-class-name="headerCellClassName"
          :edit-config="{trigger: 'dblclick', mode: 'row', activeMethod: activeRowMethod}"
          @select-all="selectAllEvent"
          @select-change="selectChangeEvent"
          :select-config="{labelField: 'name', checkMethod}"
           @sort-change="sortChangeEvent"
           :remote-sort="true"
           :row-class-name="rowClassName"
           :customs.sync="table.customColumns"
          >
          <vxe-table-column v-if="table.hasSelect" type="selection" width="40" fixed='left'></vxe-table-column>
          <vxe-table-column
           		 v-for='item in table.config' :shifouheji="true"  :field="item.value" :title="item.label"  :key='item.value' :filters="item.filters"  :filter-method="item.function"
           		:edit-render='{autoselect: true}' :formatter='item.formatter' :min-width='item.width'
           		:fixed='item.fixed'  :params='{isTotal:item.isTotal,decimalNum:item.decimalNum}'
           		:sortable='item.sortable'
            >
            <!-- 自定义修改啊 -->
            <template v-slot:edit="{ row }"
             		   v-if='item.id==="1"'>
             	<el-date-picker
             		  style='width: 100%;'
				      v-model='row[item.value]'
				      type="date"
				      :disabled='row.isBeginning===0?false:true'
				      value-format="yyyy-MM-dd"
				      placeholder="选择日期">
   				 </el-date-picker>
            </template>
             <template v-slot:edit="{ row }"
             		   v-else-if='item.id==="3" || item.id==="4"'>
             	<el-input size='big' v-model='row[item.value]' :disabled='row.isBeginning===0?false:true'
             		@input='calculationS(row,item.value)' @blur='handleBlur_s(row,item.value)' @focus='handleFocus_s(row,item.value)'
             	>{{calculation(row,item.value)}}</el-input>
            </template>
            <template v-slot:edit="{ row }"
             		   v-else-if='item.id==="2" '>
             	<el-input size='big' v-model='row[item.value]' :disabled='row.isBeginning===0?false:true'
             		@input='calculationS(row,item.value)' @blur='handleBlur_s(row,item.value)' @focus='handleFocus_s(row,item.value)' type='textarea' autosize
             	>{{calculation(row,item.value)}}</el-input>
            </template>
            <template v-slot:edit="{ row }"
             		   v-else-if='item.id==="5"'>
             	<el-input size='big' v-model='row[item.value]' :disabled='!row.edtBegining'></el-input>
            </template>
             <template v-slot:edit="{ row }"
             		   v-else-if='item.type==="number"'>
             	<el-input size='big' v-model='row[item.value].value' :disabled='row.isBeginning===0&&item.valueType!==1?false:true'></el-input>
            </template>
            <!-- 自定义修改文字 "createUser"-->
            <template v-slot:edit="{ row }"
             		   v-else-if='item.type==="text"'>
             	<el-input size='big' v-model='row[item.value].value' :disabled='item.value==="createUser"' type='textarea' autosize ></el-input>
            </template>
             <template v-slot:edit="{ row }" v-else-if='item.type==="date"'>
             	  <el-date-picker
             	 	 style='width: 100%;'
				      v-model='row[item.value].value'
				      type="date"
				      :disabled='row.isBeginning===0?false:true'
				      value-format="yyyy-MM-dd"
				      placeholder="选择日期">
   				 </el-date-picker>
            </template>
            <template v-slot:edit="{ row }" v-else-if='item.type==="select_s"'>
             	  <el-select v-model="row[item.value].id" placeholder="请选择" :disabled='row.isBeginning===1?true:false' filterable clearable>
				    <el-option
				      v-for="i in item.optionList"
				      :key="i.id"
				      :label="i.optionName"
				      :value="i.id">
				    </el-option>
				  </el-select>
            </template>
            <template v-slot:edit="{ row }" v-else-if='item.type==="select_d"' >
             	  <el-select v-model="row[item.value].id" placeholder="请选择" multiple :disabled='row.isBeginning===0?false:true' filterable clearable>
				    <el-option
				      v-for="i in item.optionList"
				      :key="i.id"
				      :label="i.optionName"
				      :value="i.id">
				    </el-option>
				  </el-select>
            </template>
            <!-- 图片上传 -->
             <template v-slot:edit="{ row }" v-else-if='item.type==="img"' >
             	 	<el-upload
			       class='picUpload'
				  :action="uploadUrl"
				 :disabled = 'row.isBeginning==1'
				  list-type="picture-card"
				  :on-success="(res, file, fileList)=>{ return handleUploadSuccess(res, file, fileList,row[item.value]) }"
				  :on-error="errorUpload"
				  :file-list="row[item.value]?row[item.value].imgList:[]"
				  :before-upload="beforeUpload"
				  :on-preview="handlePictureCardPreview"
				  :on-remove="(file)=>{return handleRemove(file,row[item.value])}">
				  <i class="el-icon-plus"></i>
				</el-upload>
            </template>
            <!-- 自定义模板 -->
            <template v-slot="{ row }">
            	<span v-if='item.type==="select_s"'>
            		<span :style='{backgroundColor:styleColor(item,row,"1"),padding:"5px 15px",color:"#fff",borderRadius:"4px" }' v-if='styleColor(item,row,"1")'>{{row[item.value]?row[item.value].name:""}}</span>
            		<span v-else>{{row[item.value]?row[item.value].name:""}}</span>
            	</span>

            	<span v-else-if='item.type==="select_d"&&row[item.value]'>
            		<span v-for='(j,index) in row[item.value].color' :key='j.id'

            		>
            			<span :style='{backgroundColor:"#EFEFEF",padding:"5px 15px",color:styleColor(item,j,"2"),borderRadius:"4px",margin:"3px",display:"inline-block" }'>{{j.name}}</span>
            			<!-- <span v-else>{{j.name}}<i v-if='index!==row[item.value].color.length-1'>，</i></span> -->
            		</span>
            	</span>
            	<span v-else-if='item.type==="number"'>{{calculation(row,item.value)}}{{returnFloat(row[item.value],item.decimalNum)}}</span>
            	<div  v-else-if='item.type==="img"&&row[item.value]'>
            		<span v-for='(i,index) in row[item.value].imgList' :key='index'>
            			<el-image
							 style='width: 30px;height:30px;margin-right: 10px;'
						    :src="i.url"
						    :preview-src-list="[i.url]">
						</el-image>
            		</span>

            	</div>
            	<span v-else>{{formartValue(row,item.value)}}


            		<!-- 修改数据 -->
            		<el-popover
					  placement="bottom-start"
					  :width="editWidth"
					  @show = "handleEditShow(row)"
					  v-if='item.id==2&&row.isBeginning!==1&&row.isUpdate===1'
					  trigger="click">
					  <!-- 表格 -->
					  <div class='editTableTitle'>
					  	修改历史
					  </div>
					  <div style='padding:0 8px 8px;'>
					  	<public-table :table="tableDataP" >
					  		<template v-for="(k,indexx) in imgListTitle"  :slot='k' slot-scope='props' >
					  			<div style="width: 100%;display: inline-block;">
						  			<el-image
						  				v-for='(d,index9) in props.scope.row[k]'
						  				:key='index9'
										style="width: 30px;height:30px;display: block;"
									    :src="d.url"
									    :preview-src-list="[d.url]">
									</el-image>
						  		</div>
					  		</template>
					  	</public-table>
					  </div>

					  <span  class='isEditHit' slot="reference">改</span>
					</el-popover>







            	</span>
            </template>


            <!-- 筛选 -->
           <template v-slot:filter="{ column, context }" v-if='item.type==="number"'>
	           	<span  v-for="(option, index) in column.filters" :key='index'>
	           		<el-input size='mini'  v-model="option.data" @input="context.changeOption($event, !!option.data, option)" style='width: 120px;' placeholder='请输入数值查询'>

	           		</el-input>
	           		<span v-if='index===0' style='margin: 0 5px;'> - </span>
	           	</span>
	           	<el-row class='filterFooter'>
	           		<el-col :span='18'>
	           			<el-button type='warning' size='mini' @click="handleSuperRest(item.value)">重置</el-button>
	           			<el-button type='warning' size='mini' @click="handleSuperRest('')">全部重置</el-button>
	           			<!-- $refs.xTable.clearFilter(item.value) -->
	           		</el-col>
	           		<el-col :span='6' style="text-align:right;">
	           			<el-button type='primary' size='mini' @click="handleFilterData(item.value)">筛选</el-button>
	           		</el-col>
	           	</el-row>
            </template>
            <template v-slot:filter="{ column, context }" v-else-if='item.type==="text"'>
	           	<span  v-for="(option, index) in column.filters" :key='index'>
	           		<el-input size='mini'  v-model="option.data" @input="context.changeOption($event, !!option.data, option)" style='width: 320px;' placeholder='请输入关键字查询'></el-input>
	           	</span>
	           	<el-row class='filterFooter'>
	           		<el-col :span='12'>
	           			<el-button type='warning' size='mini' @click="handleSuperRest(item.value)">重置</el-button>
	           			<el-button type='warning' size='mini' @click="handleSuperRest('')">全部重置</el-button>
	           		</el-col>
	           		<el-col :span='12' style="text-align:right;">
	           			<el-button type='primary' size='mini' @click="handleFilterData(item.value)">筛选</el-button>
	           			<el-button type='primary' size='mini' @click="handleFilterData(item.value,'1')">精确筛选</el-button>
	           		</el-col>
	           	</el-row>
            </template>
           			 <!-- 下拉框 -->
             <template v-slot:filter="{ column, context }" v-else-if='item.type==="select_s" || item.type==="select_d"'>
             	<el-row class='filterFooter_s'>
	           		<el-col :span='18'>
	           			<el-button type='warning' size='mini' @click="handleSuperRest(item.value)">重置</el-button>
	           			<el-button type='warning' size='mini' @click="handleSuperRest('')">全部重置</el-button>
	           		</el-col>
	           		<el-col :span='6' style="text-align:right;">
	           			<el-button type='primary' size='mini' @click="handleFilterData(item.value)">筛选</el-button>
	           		</el-col>
	           	</el-row>
	           	<span  v-for="(option, index) in column.filters" :key='index'>
	           		<el-select v-model="option.data" placeholder="请选择"  @change='context.changeOption($event, !!option.data, option)' size='small' multiple  filterable clearable>
					    <el-option
					      v-for="i in item.optionList"
					      :key="i.id"
					      :label="i.optionName"
					      :value="i.id">
					    </el-option>
					  </el-select>
	           	</span>

            </template>
            <template v-slot:filter="{ column, context }" v-else-if='item.type==="date"'>
            	<span v-for="(option, index) in column.filters" class='dateShow' :key='index'>
            		<el-date-picker
				      v-model="option.data"
				      type="date"
				      size='mini'
				      clearable
				      @change='context.changeOption($event, !!option.data, option)'
				      style='width: 150px;'
				      placeholder="请选择">
				    </el-date-picker>
				    <span v-if='index===0' style='margin: 0 5px;'> - </span>
            	</span>
	           	<el-row class='filterFooter'>
	           		<el-col :span='18'>
	           			<el-button type='warning' size='mini' @click="handleSuperRest(item.value)">重置</el-button>
	           			<el-button type='warning' size='mini' @click="handleSuperRest('')">全部重置</el-button>
	           		</el-col>
	           		<el-col :span='6' style="text-align:right;">
	           			<el-button type='primary' size='mini' @click="handleFilterData(item.value)">筛选</el-button>
	           		</el-col>
	           	</el-row>
            </template>
           </vxe-table-column>
           <vxe-table-column width="100" title='操作' fixed='right' field="操作">
           		 <template v-slot="{ row }">
           		 	<div  v-if='!(row.isBeginning===0?false:true)' style='text-align: center;'>

		            	<span @click="deleteRowEvent(row)"  style='cursor: pointer;' v-if='row.button&&row.button.length'
		            		v-for='o in row.button' :key='o.id'
		            	>
		            	  <img src="/static/icon/cashierdiary_del.png" alt="删除">
				        </span>

				       <span @click="seeRowEvent(row)" style='cursor: pointer;margin-left: .1rem;'>
				       		<img src="/static/icon/cashierdiary_look.png" alt="查看">
				       </span>
           		 	</div>
	            </template>
           </vxe-table-column>
        </vxe-table>
        <!-- 查看大图 -->
         <el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
       <!--  <vxe-pager
          :loading="table.loading"
          :current-page="table.tablePage.currentPage"
          :page-size="table.tablePage.pageSize"
          :total="table.tablePage.totalResult"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="handlePageChange">
        </vxe-pager> -->
	</div>
</template>
<script>
	import {currencys} from '@/assets/utils/currencyFormat'
	import publicTable from '@/components/publicTable'
	import { uploadUrl,imgShow } from '@/assets/js/apiConfig'
	export default {
		components:{
			publicTable
		},
		props:{
			table: {
				type: Object,
				default:{
					tablePage: {
		                currentPage: 1,
		                pageSize: 10,
		                totalResult: 0
	             	 }
				}
			},
			tableData: Array
		},
		data(){
			return {
				imgListTitle:[],  // 所有图片集合
				uploadUrl:uploadUrl,  // 上传地址
				dialogVisible:false,
				dialogImageUrl:"",
				// 修改表格数据
				tableDataP: {
					editWidth:null,     // 屏幕宽度
					Maxheight: 400,				// 限定高度
					isNotSuspensionShow: true,  // 不显示悬浮效果
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,			// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [],
					data: [],

					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center'
					}
				},
				upData:{},    // 收入支出当前修改
				allData:{},
				tableDataC:[],  // 表格数据复制
			}
		},
		created(){
			this.editWidth = document.body.clientWidth>600?document.body.clientWidth-200:600;
		},
		mounted(){

		},
		deactivated() {
			let _ = this;
			let elMain = document.querySelector('.el-main');
			// 移出滚动监听
			if(elMain) {
				elMain.removeEventListener('scroll' , _.handlScrolls)
			}
		},
		activated () {
			let _ = this;
			let elMain = document.querySelector('.el-main');
			// 开启滚动监听
			if(elMain) {
				elMain.addEventListener('scroll' , _.handlScrolls)
			}
		},
		computed: {
			editTableData:{
				get() {
					return this.table.data;
				},
				set(val) {
					this.$emit("on-change-data", val);
				}
			}
		},
		methods:{
			// 点击移出图片
			handleRemove(file,item) {
		        let nameStr = file.name;
		        // 给当前操作的图片赋值
		       	item.imgList.forEach((i,index)=>{
		        	if(i.name === nameStr) {
		        		item.imgList.splice(index,1)
		        	}
		        })

		    },
		    // 点击查看图片
		    handlePictureCardPreview(file) {
		       this.dialogImageUrl = file.url;
		       this.dialogVisible = true;
		    },
		    // 上传成功
		    handleUploadSuccess(res, file, fileList,item) {
		    	if(res&&res.code==200) {
		    		if(res.data.length) {
		    			let arr = {
		    				name:file.name,
		    				url:imgShow + res.data[0],
		    			};
		    			// 给当前操作的图片赋值
		    			item.imgList.push(arr);
		    		}
		    	}

		    },
		    // 上传失败
		    errorUpload(err, file, fileList) {
		    	console.log(err)
		    },
		    // 上传之前验证。
		    beforeUpload(file) {
		    	 const isJPG = file.type === 'image/jpeg';
		    	 const isPNG = file.type === 'image/png';
		    	 const isLt2M = file.size / 1024 / 1024 < 10;
		    	 if(!isJPG&&!isPNG) {
		    	 	this.$message.error('只能上传图片且只能是 JPG 格式或者 PNG 格式！');
		    	 }
		    	 if(!isLt2M) {
		    	 	 this.$message.error('上传图片大小不能超过 10MB!');
		    	 }
		    	 return (isJPG || isPNG) && isLt2M
		    },
			// 点击弹框显示
			handleEditShow(row) {
				this.getEditDataH(row);
			},
			// 获取修改数据
			getEditData(row) {
				this.$http.post('journal/getUpdateJournal',{id:row.id}).then(res=>{
					if(res.data&&res.data.code==1) {
						this.tableDataP.data = res.data.data;
					}
				})
			},
			isok(i) {console.log(i)},
			// 获取修改数据表头
			getEditDataH(row) {
				this.$http.post('journal/getUpdateJournalTitle',{type:"1"}).then(res=>{
					if(res.data&&res.data.code==1) {
						this.getEditData(row);
						this.imgListTitle = [];
						this.tableDataP.config = res.data.data.map((i)=>{
							if(i.customType==5) {
								i.show='template';
								this.imgListTitle.push(i.value);
							}else {
								i.show='normal';
							}

							i.label = i.columnName;
							return i;
						})
					}
				})
			},
			scrollBottomFun() {
				let s = document.querySelector('.vxe-table--body-wrapper');
			      setTimeout(()=>{
			        s.scrollTop = s.scrollHeight;

			      },0)
			},
			styleColor(item,row,t){
				let obj = item.optionList.find(i=>{
					if(t==="1") {
						if(!row[item.value]) {return ""};
					 	return i.id===row[item.value].id
					}else {
						return i.id===row.id;
					}
				})
				return obj?obj.color:"";
			},
			// 滚动监听
			handlScrolls(){
				let elMain = document.querySelector('.el-main');
				let tableHead = document.querySelector('.vxe-table--header-wrapper');
				let tableFooter = document.querySelector('.vxe-table--footer-wrapper');
				let tableBody = document.querySelector('.vxe-table--body-wrapper');
				let scrollTop = elMain.scrollTop;
				if(scrollTop>100) {
					//表头浮动
					tableBody.style.marginTop = tableHead.clientHeight+'px';
					tableBody.style.marginBottom =( tableFooter.clientHeight+100)+'px';
					tableHead.style.position = 'fixed'
					tableHead.style.top = '122px'
					tableHead.style.left = '190px'
					tableHead.style.zIndex = '8'
					// 表尾合计浮动
					tableFooter.style.position = 'fixed'
					tableFooter.style.bottom = '0px'
					tableFooter.style.left = '190px'
					tableFooter.style.zIndex = '8'
					tableFooter.style.borderLeft = '1px solid #e8eaec'

				}else {
					// d表头复位
					tableBody.style.marginTop = '0';
					tableBody.style.marginBottom = '0';
					tableHead.style.position = 'relative'
					tableHead.style.top = '0'
					tableHead.style.left = '0'
					tableHead.style.zIndex = '1'
					// 表尾复位
					tableFooter.style.position = 'relative'
					tableFooter.style.left = '0'
					tableFooter.style.zIndex = '1'
					tableFooter.style.borderLeft = 'none'

				}
			},
			// 取消筛选、全部筛选
			handleSuperRest(type) {
				this.$refs.xTable.clearFilter(type)
				//this.table.tablePage.totalResult = this.table.data.length-1;
			},
			// 期初高亮
			rowClassName ({ row, rowIndex }) {
          if(row.isBeginning===1) {
            return "hightLight_row"
          }
          if(row.backgroundColor) {
            return "hightLight_lastrow"
          }
      },
			//筛选出发  type  无则模糊筛选，1为精确筛选
			handleFilterData(value,type){
				this.tableDataC = JSON.parse(JSON.stringify(this.table.data));
				let xTable = this.$refs.xTable
	              xTable.filter(value)
	                .then(options => {  // 处理条件并设置选中的选项
	                   if(type && type==1) {  // 精确筛选
	                   	 options[0].isAccurate = true;
	                   }else {
	                   	 options[0].isAccurate = false;
	                   }


	                })
	                .then(() => {
	                  // 修改条件之后，需要手动调用 updateData 处理表格数据
	                  xTable.updateData()
	                 // this.table.tablePage.totalResult = xTable.afterFullData.length-1;
	                // this.editTableData = xTable.afterFullData;
	                 // console.log(xTable)
	                  // console.log(xTable)
	                })
			},
			// 日期数值排序
			 sortChangeEvent ({ column, property, order }) {
			 	//let sourceData = JSON.parse(JSON.stringify(this.tableData));

			 	if(order) {
	              	let data = this.editTableData.splice(0,1)
	               this.editTableData.sort((a,b)=>{
		               	if(typeof a[property]==='object'&&typeof b[property]==='object') {
		               		return (a[property].value>b[property].value?1:-1)*(order==="asc"?1:-1)
		               	}else {
		               		return (a[property]>b[property]?1:-1)*(order==="asc"?1:-1)
		               	}
	               })
	 				this.editTableData.unshift(data[0]);
			 	}else {
			 		this.editTableData = JSON.parse(JSON.stringify(this.tableData));
			 	}
			 	if(this.editTableData.length) {
			 		// 计算余额
			 		this.editTableData.forEach((item,index)=>{
			 			if(index<this.editTableData.length-1) {
			                 this.editTableData[index+1].remainingSum = Number(this.editTableData[index].remainingSum)+Number(this.editTableData[index+1].debitMoney)-Number(this.editTableData[index+1].creditorMoney);
			              }
			 		})


			 	}

              	// this.$emit('handlePageChange',{ currentPage:this.table.tablePage.currentPage, pageSize:this.table.tablePage.pageSize,tableData:this.table.data })
            },

			// 点击编辑列
			editActivedEvent({ row, column }, event) {
				this.table.dateChange = false;
				event.path.forEach(i=>{
					console.log()
					if(i.className&&i.className.split(" ")[0]==="vxe-body--row"){
						i.onclick=function(ev){
							ev.cancelBubble = true;
							ev.stopPropagation();
						}
					}
				})
			},
			// handlePageChange ({ currentPage, pageSize }) {
   //           	this.$emit('handlePageChange',{ currentPage, pageSize })
   //          },

           // 自动计算赋值
			makeAllData(data){
			    this.allData.debitMoney=!Number(data.debitMoney)?0:Number(data.debitMoney)
			    this.allData.creditorMoney=!Number(data.creditorMoney)?0:Number(data.creditorMoney)
			   	for (var obj in data) {
			   		if(obj.substring(0, 5) === "value"){
			   			if(data[obj].customType==="3"){
							let o= obj.replace("value-","field_");
	 						this.allData[o]=!Number(data[obj].value)?0:Number(data[obj].value)
			   			}
			   		}

			   	}
			   },
			// 收入支出失去焦点
			handleBlur_s(data,i) {
				if(i==="debitMoney" || i==="creditorMoney") {
					console.log(data.debitMoney,data.creditorMoney)
					// if(data.debitMoney==0&&data.debitMoney===""&&data.creditorMoney==0&&data.creditorMoney==="") {
					// 	if(i==="debitMoney") {
					// 		data.debitMoney = this.upData.creditorMoney?this.upData.creditorMoney:this.upData.debitMoney;
					// 	}else if(i==="creditorMoney") {
					// 		data.creditorMoney = this.upData.creditorMoney?this.upData.creditorMoney:this.upData.debitMoney;
					// 	}
					// }
				}

			},
			// 收入支出获得焦点
			handleFocus_s(data,i) {
				if(i==="debitMoney" || i==="creditorMoney") {
					this.upData = JSON.parse(JSON.stringify(data));
				}
			},
		   // 收入支出清空
		   calculationS(data,i) {
		   	if(i==='debitMoney') {
		   		if(data.debitMoney!=0&&data.debitMoney!=="") {
			   		data.creditorMoney = ""
			   }
		   	}else if(i==='creditorMoney'){
		   		if(data.debitMoney!=0&&data.creditorMoney!=="") {
			   			data.debitMoney = ""
		   		}
		   	}



		   },
		   // 自动计算
		   calculation(data,i){
		    this.makeAllData(data);
		    	for (var obj in data) {
		    		 if(data.isBeginning!==1&&data[obj]&&data[obj].valueType=='1'){
		    			 data[obj].value=eval(data[obj].formula)?eval(data[obj].formula):0;
		    		}
		    	}
		   },
			// 禁止编辑
			activeRowMethod({ row, rowIndex }){
				return row.edtBegining || row.isBeginning !==1
			},
			// 编辑返回
			editClosedEventRetuen() {
				return;
			},
			//保留两位小数自动补零
			returnFloat(value,num){
				if(typeof(value)==="object") {
					value = value.value;
				}
				if(!value || value===Infinity) {
					return "";
				}
				if(num!=="0"&&!Number(num)) {
					let stringified = Math.abs(value);
					let sign = value < 0 ? '-' : ''
					let value_s = stringified.toString().split(".");
					if(value_s[0]!=="") {
						const digitsRE = /(\d{3})(?=\d)/g
						let _int=value_s[0];
						let index =  _int.length % 3;
						let head = index > 0 ? (_int.slice(0, index) + (_int.length > 3 ? ',' : '')) : '';
						if(value_s[1]) {
							return sign + head + _int.slice(index).replace(digitsRE, '$1,') + "."+value_s[1];
						}else {
							return sign + head + _int.slice(index).replace(digitsRE, '$1,');
						}

					}
					return value;
				}else {
					return currencys(value,"",Number(num));
				}

			},
			formartValue(row,val){
				if(val==="createUser"&&row.isBeginning===1) {
					return "";
				}
				let value = row[val];
				if(value&&typeof(value)==="object") {
					return value.value;
				}else {
					return value;
				}
			},
			checkMethod ({ row }) {
              return !(row.isBeginning===0?false:true)
            },

			// 选择变化
			selectChangeEvent(val){

				let idList=[];
				if(val.selection.length) {
					val.selection.forEach(i=>{
						idList.push(i.id);
					})
				}else {
					idList=[];
				}
				this.$emit('idList',idList)
			},
			// 全选
			selectAllEvent(val){
				let data  = val.$table.afterFullData;
				val.$table.selection = val.$table.selection.filter((a)=>{
					for (var i = 0; i < data.length; i++) {
						let x = data[i]
						if(x.id === a.id){
					 		return x.id === a.id
					 	}
					}
				})

				let idList=[];

				if(val.$table.selection.length) {
					val.$table.selection.forEach(i=>{
						idList.push(i.id);
					})
				}else {
					idList=[];
				}

				this.$emit('idList',idList)
			},
			// 头部样式
			 headerCellClassName ({ column, columnIndex }) {
	                return 'centerStyle'
            },
            // 删除
            deleteRowEvent(row) {
            	this.$prompt('此操作将删除该行,您可在下面输入框输入删除原因(可选)', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          inputPlaceholder:"可输入删除原因",
			        }).then((val) => {
			        	this.$http.post('journal/deleteJournalPeriod' , {ids:row.id,because:val.value}).then(res=>{
							if(res&&res.data.code == 1) {
								this.$emit('successSave',true);
								this.$message({
						            type: 'success',
						            message: res.data.msg
						          });
							}
						})

			        }).catch(() => {

			        });
            },
            // 查看
            seeRowEvent(row) {
            	this.$emit("seeRowEventRow" , row);
            }
		},
		watch:{
			'table.data': {
				handler(val){
					this.table.dateChange = true;
				},
				deep:true
			}
		}
	}
</script>
<style lang='less'>
.editTableTitle {
		color: #333;
		font-size: 22px;
		padding:8px 8px 20px;
	}
	.vxe-table--filter-wrapper {
		z-index: 1999 !important;
	}
/* 	.vxe-table--filter-footer {
		display:none !important;
	} */

	.filterFooter {
		margin-top: 20px;
	}
	.filterFooter_s {
		margin-bottom: 10px !important;
	}
	#vxeTable {
		height: calc(100% - 0px);
		/*图片上传*/
		.picUpload {
			margin: 10px 0;
			.el-upload--picture-card {
				width: 60px;
				height: 60px;
				line-height: 60px;
				.el-icon-plus {

				}
			}
			.el-upload-list--picture-card .el-upload-list__item {
				width: 60px;
				height: 60px;
			}
		}
		.isEditHit {
			cursor: pointer;
			display: inline-block;
			width: 18px;
			height: 18px;
			border-radius: 50%;
			border:1px solid red;
			background-color: #fff;
			line-height: 18px;
			text-align:center;
			color: red;
			font-size: 12px;
			margin-left: 5px;
			opacity: .5;
			&:hover {
				opacity:1;
			};
		}
		.vxe-table--body {
			margin-bottom: 150px;
		}
		.dateShow {

		}
		.vxe-footer--row {
			background-color: #f8f8f9;
		}
		.centerStyle {
          text-align: center !important;
        }
        .vxe-edit-icon {
        	display: none;
        }
        .row--current {
        	background-color: #eff9f6;
        }
        .hightLight_row {
        	font-weight: 600;
        }
        .hightLight_lastrow {
        	background: #eff9f6;
        }


	}
</style>



// WEBPACK FOOTER //
// src/components/vxeTable/index.vue